import React, { createContext, useCallback, useState, useContext } from 'react';
import apiAuth from '../services/auth';
import api from '../services/api';
import { toast } from 'react-toastify';

const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    const token = localStorage.getItem('@SSPDS_SSAS:token');
    const roles = localStorage.getItem('@SSPDS_SSAS:roles');
    const client = localStorage.getItem('@SSPDS_SSAS:client');
    

    if ( token && roles && client ) {
      api.defaults.headers.authorization = `Bearer ${token}`;
      return { token, client: JSON.parse(client), roles: JSON.parse(roles) };
    }

    return {};
  });
  
  const signOut = useCallback(() => {
    localStorage.removeItem('@SSPDS_SSAS:token');
    localStorage.removeItem('@SSPDS_SSAS:roles');
    localStorage.removeItem('@SSPDS_SSAS:client');
    
    setData({});
  }, []);

  const signIn = useCallback(async ({ cpf, password }) => {
    try{
      const response = await apiAuth.post('auth', {
        cpf,
        password,
        appServerKey: "a949f24fef8a75ac2eeff764c944df8c"
      },{
        headers: { 'Content-Type': 'application/json' },
      });
      const { token, roles, client } = response.data;

      localStorage.setItem('@SSPDS_SSAS:token', token);
      localStorage.setItem('@SSPDS_SSAS:roles', JSON.stringify(roles));
      localStorage.setItem('@SSPDS_SSAS:client', JSON.stringify(client));

      api.defaults.headers.authorization = `Bearer ${token}`;

      setData({ token, roles, client });
    }catch(err){
      toast.error(err.response.data.message);
    }

  }, []);


  return (
    <AuthContext.Provider
      value={{
        client: data.client,
        roles: data.roles,
        token: data.token,
        signIn,
        signOut
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

function useAuth() {
  const context = useContext(AuthContext);

  return context;
}

export { AuthProvider, useAuth };
